const REASON_MESSAGES: Record<string, string> = {
  unmatched_form_class: "No form type matched the header identity",
  required_field_missing: "Required header fields are missing",
  ambiguous: "Multiple form types matched",
  malformed: "Header could not be parsed",
};

interface FailureSummaryProps {
  reason: { code: string; format: string; missing?: string[] };
  history: Array<{ rawHeader: string; timestamp: string; userId: string }>;
}

export function FailureSummary({ reason, history }: FailureSummaryProps) {
  return (
    <div className="failure-summary">
      <h3>Failure reason</h3>
      <p className="reason-text">
        {REASON_MESSAGES[reason.code] ?? reason.code}
      </p>
      {reason.missing && reason.missing.length > 0 && (
        <ul className="missing-list">
          {reason.missing.map((m, i) => (
            <li key={i}>{m}</li>
          ))}
        </ul>
      )}
      {history.length > 0 && (
        <details>
          <summary>Edit history ({history.length})</summary>
          <ul>
            {history.map((h, i) => (
              <li key={i}>
                {h.timestamp}: edited by {h.userId}
              </li>
            ))}
          </ul>
        </details>
      )}
    </div>
  );
}
